/* globals google */

/**
 * Fetch from Google Maps API the coordinates associated with a postal code,
 * city or address.
 *
 * @param {string} addressOrPostalCode Postal code, city or address
 * @param {string} countryCode Country code
 * @returns {Object} Location object with lat and lng
 */
async function geocodeAddress(addressOrPostalCode, countryCode) {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve) => {
        geocoder.geocode(
            {
                address: addressOrPostalCode,
                componentRestrictions: {
                    country: countryCode
                }
            },
            (results, status) => {
                let location = results?.shift()?.geometry?.location;
                let res = status === 'OK' && location ? location : null;
                resolve(res);
            }
        );
    });
}

module.exports = {
    geocodeAddress
};
